import React, { useContext, useEffect, useMemo, useRef, useState } from "react"
import { FullAnalysisCrumbs } from "../dashboardPage/components/fullAnalysis/FullAnalysisCrumbs"
import { FullAnalysisFolderList } from "../dashboardPage/components/fullAnalysis/FullAnalysisFolderList"
import { IAnalysisFolder } from "../dashboardPage/components/fullAnalysis/IAnalysisFolder";
import { AppContext } from "../../appContext";
import { linkGoogleWithPopup } from "../../api/api";
import { IFileProvider } from "../../api/fileProvider/IFileProvider";
import { GFileProvider } from "../../api/fileProvider/gFileProvider";
import { GDriveConnectButton } from "./GDriveConnectButton"
import folder1 from '../../assets/folder_filled.svg';
import { Spinner } from "../../components/spinner/Spinner";
import { FileProviderViewer } from "./FileProviderViewer";
import { FullAnalysisAddFolderPanel } from "../dashboardPage/components/fullAnalysis/FullAnalysisAddFolderPanel";

interface IGViewerProps {
    onSelect?: (item: IAnalysisFolder)=>void,
    callModal: (modal: (close: ()=>void)=>React.ReactNode)=>void;
}

export const GViewer = ({onSelect, callModal}: IGViewerProps)=>{
    return <FileProviderViewer
        callModal={callModal}
        NotConnectedView={GDriveConnectButton}
        FileProvider={GFileProvider}
        onSelect={onSelect}
    ></FileProviderViewer>
}

export const GViewerOld = ({onSelect}: IGViewerProps)=>{
    const [provider, setProvider] = useState<IFileProvider>(null);
    const [selectedItem, setSelectedItem] = useState<IAnalysisFolder>(null);
    const [notConnected, setNotConnected] = useState(false);
    const [fix, setFix] = useState(0);

    const crumbs = provider?.crumbs;
    const currentFolder = provider?.crumbs[provider?.crumbs.length-1];
    const fileInputRef = useRef<HTMLInputElement>(null);

    useEffect(()=>{
        /*if (!isGapiReady){
            return;
        }*/
        const _provider = new GFileProvider();
        _provider.onChange = ()=>{
            setFix(last=>last+1);
        }
        _provider.onAuthError = ()=>{
            setNotConnected(true);
        }
        _provider.onReady = ()=>{
            console.log('g inited')
            _provider.getFiles();
            setProvider(_provider);
        };     
    }, []);

    useEffect(()=>{
        onSelect?.(selectedItem);
    }, [selectedItem]);

    const navigateFolder = (folderId?: string)=>{
        provider.getFiles(folderId);
    }
    /*const getDriveData = (folderId: string = 'root')=>{
        return gapi.client.request({
            //path: `https://www.googleapis.com/drive/v3/files?fields=files(id,name,parents,mimeType),kind,nextPageToken&&pageSize=100&&q=mimeType%3D%27application/vnd.google-apps.folder%27+and+%27${folderId}%27+in+parents`,
            path: `https://www.googleapis.com/drive/v3/files?fields=files(id,name,parents,mimeType,iconLink,thumbnailLink),kind,nextPageToken&&pageSize=100&&q=%27${folderId}%27+in+parents`,
            //path: `https://www.googleapis.com/drive/v3/files?fields=files,kind,nextPageToken&&pageSize=100&&q=%27${folderId}%27+in+parents`,
        });
    };*/

    const handleCrumb = (folder: IAnalysisFolder)=>{
        provider.getFiles(folder.id);
    }

    const handleSelect = (folder: IAnalysisFolder)=>{
        if (selectedItem == folder){
            if (selectedItem?.type == 'folder'){
                navigateFolder(folder.id);
                //setCrumbs(last=>[...last, folder]);
                //setSelectedItem(null);
            }
        } else {
            setSelectedItem(folder);    
        }/*
        if (folder.type == 'folder'){
            navigateFolder(folder.id);
        }*/
    }

    const handleAddFolder = ()=>{
        console.log('create folder');
        const newFolder: IAnalysisFolder = {
            name: "test_folder",
            iconIndex: 0,
            date: new Date(),
            type: "folder"
        }
        provider.createFolder(newFolder, currentFolder.id);
    }

    const handleSubmitUploadFile = (file: File)=>{
        provider.createFile(file, currentFolder.id);
    }

    return <div>
        {/*<h1>Test GDrive viewer</h1>*/}
        {/*<button onClick={handleAddFolder}>create test1</button>*/}

        <input ref={fileInputRef} style={{display: 'none'}} type="file" onChange={(e)=>{
            handleSubmitUploadFile(e.target.files[0]);
        }}></input>
        {notConnected && <GDriveConnectButton onClick={()=>{
            linkGoogleWithPopup().then(tk=>{
                if (!tk?.accessToken){
                    setNotConnected(true);
                } else {
                    localStorage.setItem('gtoken', tk.accessToken);
                    gapi.client.setToken({access_token: localStorage.getItem('gtoken')});
                    setNotConnected(false);
                    navigateFolder();
                }
            });
        }}>
        </GDriveConnectButton>}
        {(!currentFolder || currentFolder.loadingStatus == 'loading') && <Spinner></Spinner>}
        {(!notConnected && crumbs && currentFolder && currentFolder.loadingStatus != 'loading') && <FullAnalysisCrumbs crumbs={crumbs} onCrumb={handleCrumb}></FullAnalysisCrumbs>}
        {(!notConnected && currentFolder && currentFolder.loadingStatus != 'loading') && <FullAnalysisFolderList 
            folder={currentFolder}
            selectedItem={selectedItem}
            onSelect={handleSelect}
            onRename={(file, name)=>{
                if (file.name != name) {
                    provider.updateFile({...file, name: name});
                }
            }}
            onDelete={(item)=>{provider.deleteFile(item.id)}}
        ></FullAnalysisFolderList>}
        {<FullAnalysisAddFolderPanel
            onAdd={handleAddFolder}
            onAddFile={()=>{fileInputRef.current.click()}}
        ></FullAnalysisAddFolderPanel>}
    </div>
}